/**
 * API 客户端：统一前缀 https://ztc1349.com/api/
 * 登录接口返回 token，后续请求 header 携带 ApiToken
 * code === 0 成功；code === -999 未登录/过期，自动清除 token 跳登录页
 */

const BASE_URL = 'https://ztc1349.com/api/';

const TOKEN_KEY = 'ztc_token';

export function getToken(): string {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function isLoggedIn(): boolean {
  return !!getToken();
}

/** 未登录跳转登录页（HashRouter） */
function redirectLogin() {
  removeToken();
  if (!window.location.hash.startsWith('#/login')) {
    window.location.hash = '#/login';
  }
}

export interface ApiResponse<T = unknown> {
  code: number;
  msg: string;
  data: T;
}

/**
 * 发起 POST 请求
 * @param path 接口路径（不含 /api 前缀），如 login、orders/buyer
 * @param data 表单参数
 * @returns 接口 data 字段
 */
export async function post<T = unknown>(path: string, data: Record<string, unknown> = {}): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  const token = getToken();
  if (token) headers.ApiToken = token;

  let res: Response;
  try {
    res = await fetch(BASE_URL + path, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    });
  } catch {
    throw new Error('网络连接失败，请检查网络后重试');
  }

  if (!res.ok) {
    throw new Error(`服务器异常（${res.status}），请稍后重试`);
  }

  const json = (await res.json()) as ApiResponse<T>;

  //未登录/token 过期
  if (json.code === -999) {
    redirectLogin();
    throw new Error(json.msg || '请先登录');
  }

  if (json.code !== 0) {
    throw new Error(json.msg || '操作失败');
  }

  return json.data;
}
